import { FC } from 'react'

import { Avatar, AvatarColorProps, Box, Text, Title } from '@factorialco/deprecated-design-system'
import { PeopleChartGroupSidepanelBasicInfoFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'

type Props = {
  basicInfo: PeopleChartGroupSidepanelBasicInfoFragment | undefined
  color?: AvatarColorProps
}

const GroupDetail: FC<Props> = ({ basicInfo, color }) => {
  return (
    <Box gap="s12">
      <Avatar
        size="s64"
        label={basicInfo?.name || ''}
        color={color}
        url={buildUrl(basicInfo?.avatar || '')}
      />
      <Box gap="s8">
        <Title title={basicInfo?.name || ''} />
        <Text.Normal>{basicInfo?.description || ''}</Text.Normal>
      </Box>
    </Box>
  )
}

export default GroupDetail
